import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface YbotState {
  activeConversationId: string | undefined;
  // The id the caller minted for a create still in flight. Selected, so the list highlights it at
  // once, but not yet a row on the server - the hub checks persisted ownership and the messages
  // query would ask for a conversation that does not exist. Cleared on success, rolled back with
  // the selection on failure.
  pendingConversationId: string | undefined;
}

const initialState: YbotState = {
  activeConversationId: undefined,
  pendingConversationId: undefined,
};

// Open state and height live in localStorage; the selection must not survive a
// project switch, so it lives here.
export const ybotSlice = createSlice({
  name: 'ybotReducer',
  initialState,
  reducers: {
    setActiveConversationId: (state, action: PayloadAction<string | undefined>) => {
      state.activeConversationId = action.payload;
      state.pendingConversationId = undefined;
    },
    selectPendingConversation: (state, action: PayloadAction<string>) => {
      state.activeConversationId = action.payload;
      state.pendingConversationId = action.payload;
    },
    confirmPendingConversation: state => {
      state.pendingConversationId = undefined;
    },
    rollbackPendingConversation: state => {
      if (state.activeConversationId === state.pendingConversationId) {
        state.activeConversationId = undefined;
      }

      state.pendingConversationId = undefined;
    },
    // Called by resetAllSlices() on project switch; conversations are listed per project.
    resetState: () => initialState,
  },
});

export const {
  confirmPendingConversation,
  rollbackPendingConversation,
  selectPendingConversation,
  setActiveConversationId,
} = ybotSlice.actions;
